import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { registerPhoneVerificationNavigator } from 'utils/phoneVerificationGate';

/**
 * T2-7517: while a talent screen is open, the verification flow opened by a
 * "phone not verified" answer navigates inside React (no full app reload).
 */
export default function usePhoneVerificationNavigator() {
  const history = useHistory();
  useEffect(() => registerPhoneVerificationNavigator({
    goToProfile: () => history.push('hygienistProfile'),
    goToSupport: () => history.push('hygienistContactSupport'),
  }), [history]);
}
